/* eslint-disable no-unused-vars */

import _ from 'lodash';
import React from 'react';

import Modal from '@components/modal';

import style from './style.module.scss';

const BookMarkModal = ({
  open,
  setOpen,
  statusText,
  modalTextUpper,
  modalTextLower,
  textBtn,
  progressData,
  onSubmit,
  onDelete,
  disabledBtn = false,
  editMode = false
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      icon={'book-mark-icon'}
      statusText={statusText}
      modalTextUpper={() => <>{modalTextUpper}</>}
      modalTextLower={modalTextLower}
      textBtn={textBtn}
      progressData={progressData}
    >
      <div>
        <div className={style.modalBtn}>
          <button
            className={'btn-fill button-large modal-btn-height'}
            onClick={onSubmit}
            disabled={disabledBtn}
          >
            Save BookMark
          </button>
        </div>
        {editMode && (
          <div className={style.modalCancelBtn}>
            <button className={'btn-fill-red button-large modal-btn-height'} onClick={onDelete}>
              Delete bookmark
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default React.memo(BookMarkModal, _.isEqual);
